import React from 'react';

const RmsDashboardPage = () => <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
	<h1 className="text-xl font-semibold text-gray-900">RMS</h1>
	<p className="mt-4 text-sm text-gray-600">RMS dashboard is coming soon.</p>
</main>;

export default RmsDashboardPage;
